<template>
  <div>
    <el-upload
      :action="actionSrc"
      list-type="picture-card"
      :file-list="files"
      :on-remove="handleRemove"
      :before-upload="beforeAvatarUpload"
      :headers="headerObj"
      :on-success="successFn"
      :on-error="errorFn"
      :on-exceed="exceedLength"
      :on-progress="uploadVideoProcess"
      style="border-radius: 4px; padding: 10px"
    >
      <i class="el-icon-plus" />

      <div slot="tip" class="el-upload__tip" style="color: #e6a23c">
        仅支持上传jpg/png/jpeg格式文件，单个图片大小不超过500kb。
      </div>
    </el-upload>
  </div>
</template>
<script>
export default {
  props: {
    fileSrc: {
      type: Array,
      default: () => [],
    },
    fileId: {
      type: String,
      default: "",
    },
    watchFlag: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      files: [],
      loadProgress: 0, // 动态显示进度条
      progressFlag: false, // 关闭进度条
      dialogImageUrl: "",
      dialogVisible: false,
      srcArray: [],
      headerObj: {
        Authorization: "Bearer " + localStorage.getItem("Token"),
      },
      actionSrc: process.env.VUE_APP_BASE_API + "/api/Img/UploadImg",
    };
  },
  watch: {
    fileSrc(newName, oldName) {
      console.log("值发生变化");
      this.showFn();
    },
  },
  mounted() {
    // console.log('我是：mounted')
  },
  created() {
    console.log("我是：created", this.fileSrc);
    this.showFn();
  },
  methods: {
    // 回显
    showFn() {
      // 回显图片
      this.files = this.fileSrc.map((t, index) => {
        return {
          name: "图片" + index,
          url: t,
        };
      });
      this.$forceUpdate();
      // 编辑的时候需要加上原来的图片id
      this.srcArray = [];
      this.srcArray = this.srcArray.concat(this.fileSrc);
      console.log(this.srcArray, this.fileSrc, "this.files");
      // if (this.fileId !== "") {

      //   // 回显图片
      //   this.files = this.fileSrc.map((t, index) => {
      //     var obj = {};
      //     obj.url = this.fileSrc[index];
      //     obj.uid = t;
      //     return obj;
      //   });
      //   console.log(this.files, "this.files");
      //   // 编辑的时候需要加上原来的图片id
      //   this.srcArray = [];
      //   this.srcArray = this.srcArray.concat(fileIdArray);
      // } else {
      //   // 添加
      //   this.files = [];
      //   this.srcArray = [];
      // }
    },
    // 删除
    handleRemove(file, fileList) {
      console.log(file, "删除");
      var delId = file.url;

      // 删除图片的同时删除提交的图片ID
      this.srcArray.forEach((e, i) => {
        if (e.indexOf(delId) !== -1) {
          this.srcArray.splice(i, 1);
        }
      });
      // console.log(file, fileList);
      // console.log(this.srcArray, "删除");
      this.$emit("setFileId", this.srcArray.join(","));
    },
    // 请求报错
    errorFn(err, file, fileList) {
      console.log(err, file, fileList, "shibai");
      this.$message.error("上传失败!");
    },
    // 请求成功
    successFn(res, file, fileList) {
      console.log(file, res.response, "添加");
      this.srcArray.push(res.response);
      console.log(this.srcArray);
      this.$emit("setFileId", this.srcArray.join(","));
    },
    // 进度条
    uploadVideoProcess(event, file, fileList) {
      this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
      if (this.loadProgress >= 100) {
        this.loadProgress = 100;
        // setTimeout(() => { this.progressFlag = false }, 1000) // 一秒后关闭进度条
      }
    },
    // 文件上传之前做处理
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (this.srcArray.length >= 10) {
        this.$message.error("最多只能上传10张图片!");
        return false;
      }
      if (["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) === -1) {
        this.$message.error("上传图片格式不正确!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      // const isSize = new Promise(function (resolve, reject) {
      //   const width = 750;
      //   const height = 500;
      //   const _URL = window.URL || window.webkitURL;
      //   const img = new Image();
      //   img.onload = function () {
      //     const valid = img.width <= width && img.height <= height;
      //     valid ? resolve() : reject();
      //   };
      //   img.src = _URL.createObjectURL(file);
      // }).then(
      //   () => {
      //     // 调用上传接口
      //   },
      //   () => {
      //     this.$message.error("上传的图片最大尺寸为750*500!");
      //     return Promise.reject();
      //   }
      // );
      // return isSize;
    },
    exceedLength() {
      this.$message.error("最多只能上传10张图片!");
      return false;
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
